import {
  LunaClient,
  ClementineAuthClient,
  NotifierClient,
  VAReporterClient,
  apiContainer,
  LunaStreamsClient,
} from '@vlabs/api-bindings';
import { LunaPointClient } from '@vlabs/api-bindings/src/luna-point';

apiContainer.add('lunaClient', new LunaClient('/api/lp5'));
apiContainer.add('clementineAuthClient', new ClementineAuthClient());
apiContainer.add('notifierClient', new NotifierClient());
apiContainer.add('lunaStreamsClient', new LunaStreamsClient('/api/luna-streams'));
apiContainer.add('vaReporterClient', new VAReporterClient());
apiContainer.add('lunaPointClient', new LunaPointClient('/api/luna-point'));
